module.exports = __webpack_public_path__ + "static/img/avatar_7.11a5f1b.png";


//////////////////
// WEBPACK FOOTER
// ./static/avatars/avatar_7.png
// module id = 1598
// module chunks = 61